import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import EastRoundedIcon from '@mui/icons-material/EastRounded'
import { Box } from '@mui/material'
import { useTranslate } from 'ra-core'
import { useRecordContext } from 'react-admin'

import { INCIDENT_REPORT_ACTION_ASSIGN_OWNERSHIP } from '../../../config/damages'
import OwnershipSelectInput, { IncidentOwnershipField } from '../OwnershipSelectInput'
import { ActionCommentSection, ActionModalSection, IncidentReportActionDialog, useActionSubmit } from './common'

export const AssignOwnershipFormDialog = ({ open, onClose }) => {
  const record = useRecordContext()
  const translate = useTranslate()
  const [submitAction, isLoading] = useActionSubmit(record.id, onClose)

  const onSubmitAction = (values) =>
    submitAction(
      INCIDENT_REPORT_ACTION_ASSIGN_OWNERSHIP,
      {
        comment: values.comment || '',
        details: Object.fromEntries(Object.entries(values).filter(([key]) => key !== 'comment')),
      },
      'resources.incident-reports.actions.assign_ownership.success',
    )

  return (
    <IncidentReportActionDialog
      open={open}
      onClose={onClose}
      isLoading={isLoading}
      i18nPrefix="resources.incident-reports.actions.assign_ownership"
      formProps={{ defaultValues: { ...record, ownership: '' }, mode: 'onChange' }}
      footerProps={{
        confirmLabelKey: 'resources.incident-reports.actions.assign_ownership.confirmLabel',
        transitionFieldName: 'ownership',
        onSubmitAction,
      }}
    >
      <ActionModalSection
        title={translate('resources.incident-reports.fields.ownership')}
        titleIcon={AssignmentIndIcon}
        helperKey="resources.incident-reports.actions.assign_ownership.ownershipHelp"
        sx={{ mt: 0 }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) 28px minmax(0, 1fr)' },
            columnGap: 1.5,
            rowGap: 1.25,
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              height: 40,
              boxSizing: 'border-box',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              px: 1.25,
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'action.hover',
            }}
          >
            <IncidentOwnershipField value={record.ownership} />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', color: 'text.secondary' }}>
            <EastRoundedIcon sx={{ fontSize: 18 }} />
          </Box>
          <Box
            sx={{
              height: 56,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              '& .MuiFormControl-root': { width: '100%', m: 0 },
            }}
          >
            <OwnershipSelectInput excludeValues={[record.ownership]} />
          </Box>
        </Box>
      </ActionModalSection>
      <ActionCommentSection />
    </IncidentReportActionDialog>
  )
}
